import React from 'react';
import { i18n } from 'config/locales';

import { CITIZENSHIP, CITIZENSHIP_PASSPORTS } from 'config/formSections/citizenship';

import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';

import BranchCollection from 'components/Form/BranchCollection';
import Comments from 'components/Form/Comments';
import PassportItem from './PassportItem';

const sectionConfig = {
  key: CITIZENSHIP_PASSPORTS.key,
  section: CITIZENSHIP.name,
  store: CITIZENSHIP.store,
  subsection: CITIZENSHIP_PASSPORTS.name,
  storeKey: CITIZENSHIP_PASSPORTS.storeKey,
};

export class Passports extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.handleError = this.handleError.bind(this);
    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      Passports: this.props.Passports,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...queue,
    });
  };

  updatePassports = (values) => {
    const hasPassport = this.hasPassport(values?.items);
    this.update({
      Passports: values,
      SummaryComments: hasPassport ? this.props.SummaryComments : {}
    });
  };

  updateComments = (values) => {
    this.update({
      Comments: values,
    });
  };

  updateSummaryComments = (values) => {
    this.update({
      SummaryComments: values,
    });
  };

  branchComment = () => {
    const branchAttribute = 'Passports';
    return (
      <Comments
        title={i18n.t('citizenship.comments.branch')}
        name={`${branchAttribute}Comments`}
        className="optional-comment"
        attribute={`${branchAttribute}Comments`}
        {...this.props.Comments}
        onUpdate={this.updateComments}
        required={false}
      />
    );
  };

  hasPassport = (items = []) => items?.some(({ Item }) => Item?.Has?.value === 'Yes');

  render() {
    const branchAttribute = 'Passports';
    const hasPassport = this.hasPassport(this.props.Passports?.items);
    return (
      <div
        className="section-content passports"
        data-section={CITIZENSHIP.key}
        data-subsection={CITIZENSHIP_PASSPORTS.key}
      >
        <h1 className="section-header">{i18n.t('citizenship.destination.passports')}</h1>
        <BranchCollection
          label={i18n.t('citizenship.multiple.heading.hasforeignpassport')}
          appendLabel={i18n.t('citizenship.multiple.collection.passport.appendTitle')}
          className="has-foreignpassport"
          {...this.props.Passports}
          scrollToBottom={this.props.scrollToBottom}
          onUpdate={this.updatePassports}
          scrollIntoView={this.props.scrollIntoView}
          required={this.props.required}
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          attribute={branchAttribute}
          branchComment={this.branchComment}
        >
          <PassportItem
            name="Item"
            bind
            defaultState={this.props.defaultState}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
          />
        </BranchCollection>
        {hasPassport && (
          <Comments
            title={i18n.t('citizenship.comments.summary')}
            name={`${branchAttribute}SummaryComments`}
            className="optional-summary-comment"
            attribute={`${branchAttribute}SummaryComments`}
            {...this.props.SummaryComments}
            onUpdate={this.updateSummaryComments}
            required={false}
          />
        )}
      </div>
    );
  }
}

Passports.defaultProps = {
  Passports: { items: [] },
  SummaryComments: {},
  Comments: {},
  onUpdate: () => { },
  onError: (value, arr) => arr,
  dispatch: () => { },
  defaultState: true,
  scrollToBottom: '.bottom-btns',
  required: false,
  scrollIntoView: false,
  errors: [],
};

export default connectSubsection(Passports, sectionConfig);
